import React,{useEffect,useRef} from "react";
import PriceCards from "./PriceCards";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Pricing = ()=>{

    const Title = useRef(null);
    const sub = useRef(null);
    const head = useRef(null);


    useEffect(() => {
        gsap.set(Title.current, { opacity: 0, y: 100 });
        gsap.set(sub.current, { opacity: 0, y: 100 });
        gsap.set(head.current, { opacity: 0, y: 100 });

        gsap.to(Title.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: Title.current,
                start: "top 100%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });

        gsap.to(sub.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: sub.current,
                start: "top 100%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });

        gsap.to(head.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: head.current,
                start: "top 100%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });
    },[]);


    return(
        <section id="Pricing" className="pt-0 xl:pt-24 font-guton">
            <div className="flex flex-col items-center pb-10 max-w-[1440px] mx-auto">
                <h2 ref={head} className="text-8 md:text-14 xl:text-21 text-white text-center">Pricing</h2>
                <p ref={Title} className="text-21 md:text-35 xl:text-64 font-medium text-white text-center leading-21 md:leading-32 xl:leading-55 w-90 md:w-75 mx-auto tracking-[-1px] xl:tracking-[-3px] mb-2 xl:mb-4">Your Study Abroad Journey<br/> <span className="text-red">Your Way</span></p>
                <p ref={sub} className="text-12 xl:text-24 text-white text-center leading-12 xl:leading-24 w-70 mb-4 xl:mb-10">We’ve designed flexible packages tailored to meet your specific needs—whether you’re looking for foundational support or full guidance. </p>
                <PriceCards />
                <p className="text-9 leading-9 xl:text-16 text-grey w-70 md:w-40 xl:w-35 text-center xl:leading-18 my-1 xl:my-0 tracking-[-0.1px]">NOTE: All external costs such as SIM cards, bank account fees, transportation during tours, and personal fees are paid by the client.</p>
            </div>
        </section>
    )
}


export default Pricing;